/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { Input } from "reactstrap";

import { Button } from "../../../Helper/Button";

interface SignalBulkBarProps {
    count: number;
    onResolveReject: (status: "resolved" | "rejected", note?: string) => void;
    onClear: () => void;
    isSubmitting?: boolean;
}

/** Sticky bulk-action toolbar; visible only when rows are selected. Resolve /
 *  Reject run as parallel PUTs (each writes its own audit event). */
export const SignalBulkBar: React.FC<SignalBulkBarProps> = ({ count, onResolveReject, onClear, isSubmitting }) => {
    const [note, setNote] = useState("");

    if (count === 0) return null;

    const act = (status: "resolved" | "rejected") => {
        onResolveReject(status, note.trim() || undefined);
        setNote("");
    };

    return (
        <div className="bg-white border rounded-2 shadow-sm p-2 d-flex flex-wrap align-items-center gap-2">
            <span className="fw-bold small">{count} selected</span>
            <Input
                type="text"
                bsSize="sm"
                className="flex-grow-1"
                style={{ minWidth: 160 }}
                placeholder="Optional note for all…"
                value={note}
                onChange={(e) => setNote(e.target.value)}
            />
            <Button color="success" size="sm" onClick={() => act("resolved")} isLoading={isSubmitting}>Resolve</Button>
            <Button color="danger" size="sm" outline onClick={() => act("rejected")} isLoading={isSubmitting}>Reject</Button>
            <Button color="secondary" size="sm" outline onClick={onClear}>Clear</Button>
        </div>
    );
};

export default SignalBulkBar;
